
      import { createComponent } from '@lit/react'
      import { type EventName } from '@lit/react'
      import * as React from 'react'

      import Component from '../../components/link/link.component.js'
      import type { DdsClickEvent } from '../../events/events'
      export type { DdsClickEvent } from '../../events/events'

      const tagName = 'dap-ds-link'

      /**
 * `dap-ds-link`
 * @summary A link is a reference to a web resource.
 * @element dap-ds-link
 * @title - Link
 *
 * @event {{ event: Event }} dds-click - Emitted when the link is clicked.
 *
 * @slot - The text of the link.
 *
 * @csspart base - The main link container.
 * @csspart text - The text of the link.
 *
 * @cssproperty --dds-link-color - The color of the link text
 * @cssproperty --dds-link-hover-color - The color of the link text on hover
 * @cssproperty --dds-link-active-color - The color of the link text when active
 * @cssproperty --dds-link-visited-color - The color of the visited link text
 * @cssproperty --dds-link-font-size - The font size of the link text
 * @cssproperty --dds-link-line-height - The line height of the link text
 * @cssproperty --dds-link-font-weight - The font weight of the link text
 * @cssproperty --dds-link-text-decoration - The text decoration of the link
 *
 * @cssproperty --dds-link-neutral-color - The color of the neutral variant link
 * @cssproperty --dds-link-neutral-hover-color - The hover color of the neutral variant link
 * @cssproperty --dds-link-neutral-active-color - The active color of the neutral variant link
 * @cssproperty --dds-link-neutral-visited-color - The visited color of the neutral variant link
 *
 * @cssproperty --dds-link-brand-color - The color of the brand variant link
 * @cssproperty --dds-link-brand-hover-color - The hover color of the brand variant link
 * @cssproperty --dds-link-brand-active-color - The active color of the brand variant link
 * @cssproperty --dds-link-brand-visited-color - The visited color of the brand variant link
 *
 * @cssproperty --dds-link-inverted-color - The color of the inverted variant link
 * @cssproperty --dds-link-inverted-hover-color - The hover color of the inverted variant link
 * @cssproperty --dds-link-inverted-active-color - The active color of the inverted variant link
 * @cssproperty --dds-link-inverted-visited-color - The visited color of the inverted variant link
 *
 * @cssproperty --dds-link-warning-color - The color of the warning variant link
 * @cssproperty --dds-link-warning-hover-color - The hover color of the warning variant link
 * @cssproperty --dds-link-warning-active-color - The active color of the warning variant link
 * @cssproperty --dds-link-warning-visited-color - The visited color of the warning variant link
 *
 * @cssproperty --dds-link-disabled-color - The color of the disabled link
 * @cssproperty --dds-link-disabled-hover-color - The hover color of the disabled link
 * @cssproperty --dds-link-disabled-active-color - The active color of the disabled link
 * @cssproperty --dds-link-disabled-visited-color - The visited color of the disabled link
 *
 * @cssproperty --dds-link-lg-font-size - The font size of the large link
 * @cssproperty --dds-link-lg-line-height - The line height of the large link
 * @cssproperty --dds-link-md-font-size - The font size of the medium link
 * @cssproperty --dds-link-md-line-height - The line height of the medium link
 * @cssproperty --dds-link-sm-font-size - The font size of the small link
 * @cssproperty --dds-link-sm-line-height - The line height of the small link
 * @cssproperty --dds-link-xs-font-size - The font size of the extra small link
 * @cssproperty --dds-link-xs-line-height - The line height of the extra small link
 *
 * @cssproperty --dds-link-normal-font-weight - The font weight of the normal link
 * @cssproperty --dds-link-bold-font-weight - The font weight of the bold link
 *
 * @cssproperty --dds-link-no-underline-text-decoration - The text decoration when underline is removed
 */
      const reactWrapper = createComponent({
        tagName,
        elementClass: Component,
        react: React,
        events: {
          onDdsClick: 'dds-click' as EventName<DdsClickEvent>
        },
        displayName: "DapDSLink"
      })

      export default reactWrapper
    